import moment from "moment"
import { CrudProvider } from "../../../../services/loggedin/CrudContext"
import { ChartsComponent } from "../../../parts/crud/Charts"
import useIntl from "react-intl/src/components/useIntl"
import { getBaseBarChartOptions } from "../../../parts/crud/Types"
import { useEffect, useState } from "react"

export const WidgetEventsRecap = (props:any) => {
  const intl = useIntl()
  const days = props && props.days ? props.days : 7
  let params: any = {
      title: intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_RECAPS.TITLE'}),
      subtitle: intl.formatMessage({id: 'GENERIC.X_GIORNI_PRECEDENTI'}).replace('{x}', days) ,
      yAxisTitle: intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_RECAPS.YAXISTITLE'}),
  
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:,.0f} ' + intl.formatMessage({id:"REPORT_DEVICE.EVENTS_RECAPS.TOOLTIP"}) + '.</b> <br/>',
    }
    let baseChartOptions: any = {...getBaseBarChartOptions(params)}
    baseChartOptions.chart = {type: 'pie'}
    baseChartOptions.xAxis = {type: 'category'}
    baseChartOptions.legend = {
      layout: 'vertical',
  
      verticalAlign: 'bottom',
     
      title: {text: ':: ' + intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_RECAPS.LEGEND_TITLE'})},
   
      borderWidth: 1,
      backgroundColor: '#FFFFFF',
    }
    baseChartOptions.plotOptions = {
      pie: {
          size: '100%',
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y:,.0f}',
              style: {
                  color: 'black'
              }
          },
          showInLegend: true
      }
  };

  const [filterData, setFilterData] = useState<any>({});
    
      useEffect(() => {
        const newFilterData =  {
          server: 'all',
    
          tz: new Date().getTimezoneOffset(),
          date_range: {
            start: moment().subtract(days, 'days'),
            end: moment(),
          },
        }
        setFilterData(newFilterData);
      }, [days]); 
      /*
  const filterData = {
      server: 'all',

      tz: new Date().getTimezoneOffset(),
      date_range: {
        start: moment().subtract(days, 'days'),
        end: moment(),
      },
    }
      */

    if(!filterData || Object.keys(filterData).length===0){
      return <></>
    }
return (
    <>
      <CrudProvider api='reports/recap'>
        <ChartsComponent disableError={true} filterData={filterData} chartOnly='true' baseChartOptions={baseChartOptions}></ChartsComponent>
      </CrudProvider>
    </>
  )
}